export default __webpack_public_path__ + "static/media/do2meclient.a0fba90e.jpg";